module.exports = __webpack_public_path__ + "img/researchgate.62bb3fd9.png";